import { useContext, useState } from "react"
import '../style/pages/investory.css';
import '../style/pages/category.css';
import { deleteItem, recodeNow, update } from "../components/indexDB/indexDBStora";
import { config } from "../context/config";
import { action } from "../context/action";
import { dataa } from "../context/data";
import { switchh } from "../context/switch";
import { collection } from "../context/collect";
import { intialData } from "../context/initial";
import { useTranslation } from "react-i18next";


export default function Category() {
    const { stylingNav } = useContext(config);
    const { t } = useTranslation();
    const {setErrorMessage, errorMessage, successMessage, setSuccessMessage, editMode, setEditMode} = useContext(action);
    const { categoryText, setCategoryText } = useContext(collection)
    const { intialCategory } = useContext(intialData)
    const { category } = useContext(dataa);
    const { loadingProcess, setLoadingProcess } = useContext(switchh);
    const intitialCateg = {id: '', oldName: '', newName: ''}
    const [editText, setEditText] = useState(intitialCateg)
    const createNewCategory = async (e) => {
        e.preventDefault();
        await setLoadingProcess(true)
        setSuccessMessage("")
        if(!categoryText.name) {
            setErrorMessage("the category field empty");
            setLoadingProcess(false)
            return;
        }
        setErrorMessage("");
        recodeNow(categoryText, "categories");
        setCategoryText(intialCategory);
        setLoadingProcess(false)
    }

    const updateCategory = async (id, newName) => {
        setLoadingProcess(true)
        setSuccessMessage("");
        if(!id) {
            setErrorMessage("sorry, id not found");
            setLoadingProcess(false);
            return;
        }
        if(!newName) {
            setErrorMessage("please enter your new name");
            setLoadingProcess(false);
            return;
        }
        if(editText.oldName === newName) {
            setErrorMessage("please choose new category name");
            setLoadingProcess(false);
            return;
        }
        try {
            const data = {
                id: id,
                name: newName
            }
            await update("categories", data);
            setLoadingProcess(false)
            setEditText(intitialCateg);
            setEditMode(false)
        }
        catch(error) {
            console.log("error -> ", error);
            setLoadingProcess(false)
        }
    }

    const deleteCategory = async (id) => {

        setSuccessMessage("");
        setEditMode(false)
        
        await setLoadingProcess(true)
        if(!id) {
            setErrorMessage("sorry, no id founded");
            setLoadingProcess(false);
            return;
        }
        try {
            await deleteItem("categories", id);

            setLoadingProcess(false);
        }
        catch(error) {
            console.log(error);
            setErrorMessage("something went wrong");
            setLoadingProcess(false);
        }
    }

    return (
        <div className={`investory category page ${!stylingNav ? "page-grow" : "page-shrink"}`}>
            <h2 className="text-weight-light">{t("sections:category.full")}</h2>
            {editMode ? 
            <form onSubmit={(e) => {
                e.preventDefault();
                updateCategory(editText.id, editText.newName);
            }} className="form-add">
                <label>{t("label:category.edit")}</label>
                <input onChange={(e) => setEditText((prev) => ({...prev, newName: e.target.value}))} value={editText.newName} type="text" placeholder="ادخل الأسم الجديد" />
                <button disabled={loadingProcess}>{loadingProcess ? t("common:loading") : t("action:change")}</button>
                <button type="button" onClick={() => {
                    setEditMode(false);
                    setCategoryText("");
                    setLoadingProcess(false)
                }}>x</button>
            </form>
            :
            <form onSubmit={createNewCategory} className="form-add">
                <label>{t("label:category.label")}</label>
                <input autoFocus onChange={(e) => setCategoryText((prev)=>({...prev, name: e.target.value}))} value={categoryText.name} type="text" 
                    placeholder={t("placeholder:category.writeCategory")} />
                <button disabled={loadingProcess}>{loadingProcess ? t("common:loading") : t("common:add")}</button>
            </form>
            }
            <p className="error">{errorMessage}</p>
            <p className="success">{successMessage}</p>
            <table>
                <thead>
                    <tr>
                        <th>{t("common:id")}</th>
                        <th>{t("label:category.table.name")}</th>
                        <th className="center">{t("common:action")}</th>
                    </tr>
                </thead>
                <tbody>
                    {
                    category ?
                    
                    category.map((e,i) => 
                        <tr key={i}>
                            <td>{i + 1}</td>
                            <td>{e.name}</td>
                            <td className="action">
                                <button onClick={() => {
                                    setCategoryText("")
                                    setEditMode(true)
                                    setEditText((prev) => ({...prev, id: e.id, oldName: e.name, newName: e.name}))
                                    }} className="normal-bg">{t("action:edit")}</button>    
                                <button onClick={() => deleteCategory(e.id)} className="error-bg">{t("action:delete")}</button>    
                            </td>
                        </tr>
                    )
                    :
                    <tr>
                        <td className="no-data" colSpan={7}>no data found</td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
    )
}